import React from 'react';
import ReactDOM from 'react-dom';
import { I18nextProvider } from 'react-i18next';
import './i18n';
import i18n from './i18n';
import App from './App';
import './index.css';
import * as serviceWorker from './serviceWorker';
import { applyDeviceRules } from './modules/hostInfo';
import { applyScreenZoom, getStoredScreenZoom } from './utils/screenZoom';

// Zoom escolhido pelo operador neste equipamento, antes do primeiro render.
applyScreenZoom(getStoredScreenZoom());

const render = () =>
  ReactDOM.render(
    <React.StrictMode>
      <I18nextProvider i18n={i18n}>
        <App />
      </I18nextProvider>
    </React.StrictMode>,
    document.getElementById('root')
  );

// Regras por modelo (modules/hostInfo/deviceRules.ts) rodam antes do app: podem
// mandar o aparelho para outra URL. Sem regras, o app abre na hora.
applyDeviceRules()
  .then((result) => {
    if (!result.redirectedTo) render();
  })
  .catch(render);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
